<div class="py-4">
  <div class="flex items-end gap-3 flex-wrap">
    <!-- Search -->
    <div class="flex flex-col gap-1.5 flex-1 min-w-48 max-w-96">
      <label class="text-xs font-semibold text-navy-600 tracking-wider">People Involved</label>
      <div class="relative">
        <img
          src="/icons/search-icon.svg"
          class="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 pointer-events-none"
          alt=""
        />
        <input
          type="text"
          [value]="search()"
          (input)="setSearch($any($event.target).value)"
          [placeholder]="searchPlaceholder()"
          class="w-full pl-8 pr-3"
        />
      </div>
    </div>

    <!-- Program -->
    <div class="flex flex-col gap-1.5 min-w-40">
      <label class="text-xs font-semibold text-navy-600 tracking-wider">Program</label>
      <app-select
        placeholder="Select All"
        [options]="programs()"
        [value]="selectedProgram()"
        (changed)="setProgram($event)"
      />
    </div>

    <!-- Category -->
    <div class="flex flex-col gap-1.5 min-w-36">
      <label class="text-xs font-semibold text-navy-600 tracking-wider">Category</label>
      <app-select
        placeholder="Select All"
        [options]="categories()"
        [value]="selectedCategory()"
        (changed)="setCategory($event)"
      />
    </div>

    <!-- Stage (optional) -->
    @if (stages().length) {
      <div class="flex flex-col gap-1.5 min-w-36">
        <label class="text-xs font-semibold text-navy-600 tracking-wider">Stage</label>
        <app-select
          placeholder="Select All"
          [options]="stages()"
          [keepOrder]="true"
          [value]="selectedStage()"
          (changed)="setStage($event)"
        />
      </div>
    }

    <!-- Status (optional) -->
    @if (statuses().length) {
      <div class="flex flex-col gap-1.5 min-w-36">
        <label class="text-xs font-semibold text-navy-600 tracking-wider">Status</label>
        <app-select
          placeholder="Select All"
          [options]="statuses()"
          [value]="selectedStatus()"
          (changed)="setStatus($event)"
        />
      </div>
    }

    <!-- Date Range -->
    <div class="flex flex-col gap-1.5">
      <label class="text-xs font-semibold text-navy-600 tracking-wider">Date Range</label>
      <app-date-range-picker
        [dateFrom]="dateFrom()"
        [dateTo]="dateTo()"
        (rangeChange)="onRangeChange($event)"
      />
    </div>

    <!-- Reset -->
    <button
      (click)="reset()"
      class="text-sm text-accent-500 hover:text-primary-600 font-semibold whitespace-nowrap h-9 px-1 transition-colors cursor-pointer"
    >
      Reset filters
    </button>
  </div>
</div>
